"use client";

import { buildParticipantSurveyItems } from "@/features/participant/components/participantSurvey";
import { useStore } from "@/store";

type ParticipantSurveyPhase = "pre" | "post";

export function useParticipantSurveyDraft(phase: ParticipantSurveyPhase) {
  const draft =
    phase === "pre"
      ? useStore.use.preSurveyDraft()
      : useStore.use.postSurveyDraft();
  const updateDraft =
    phase === "pre"
      ? useStore.use.updatePreSurveyDraft()
      : useStore.use.updatePostSurveyDraft();
  const resetDraft =
    phase === "pre"
      ? useStore.use.resetPreSurveyDraft()
      : useStore.use.resetPostSurveyDraft();

  const setPain = (pain: number) => updateDraft({ pain });
  const setEnergy = (energy: number) => updateDraft({ energy });
  const setPositivity = (positivity: number) => updateDraft({ positivity });

  return {
    ...draft,
    resetDraft,
    setEnergy,
    setPain,
    setPositivity,
    surveyItems: buildParticipantSurveyItems({
      phase,
      pain: draft.pain,
      energy: draft.energy,
      positivity: draft.positivity,
      onPainChange: setPain,
      onEnergyChange: setEnergy,
      onPositivityChange: setPositivity,
    }),
  };
}
